import type { DeletedNativeProperty } from '@/api/core/native-property-read';
import { formatDateTimeWithOffset } from '@/lib/format';
import { Badge, DataTable, type DataTableColumn } from '@mgrvtechgroup/admin-ds';
import type { LucideIcon } from 'lucide-react';

const COLUMNS: DataTableColumn<DeletedNativeProperty>[] = [
  { key: 'name', header: '지점명', cell: (row) => row.name },
  { key: 'code', header: '코드', cell: (row) => row.code },
  { key: 'state', header: '상태', cell: () => <Badge tone="neutral">삭제됨</Badge> },
  {
    key: 'deleted_at',
    header: '삭제 시각',
    cellClassName: 'tabular-nums text-muted-foreground',
    cell: (row) => (
      <time dateTime={row.deleted_at}>{formatDateTimeWithOffset(row.deleted_at)}</time>
    ),
  },
];

/** 삭제된 지점은 읽기 전용이라 이름을 링크로 만들지 않는다(상세·판매 설정으로 갈 수 없다). */
export function DeletedNativePropertyTable({
  rows,
  isLoading,
  empty,
}: {
  rows: readonly DeletedNativeProperty[];
  isLoading: boolean;
  empty: { title: string; description: string; icon: LucideIcon };
}) {
  return (
    <DataTable
      columns={COLUMNS}
      data={[...rows]}
      rowKey={(row) => row.id}
      isLoading={isLoading}
      empty={empty}
    />
  );
}
